<template>
    <div>
      <h2>Результат</h2>
      <button @click="copyText">Скопіювати текст</button>
      <button @click="toggleExpand">{{ isExpanded ? 'Показати менше' : 'Показати більше' }}</button>
      
      <div class="json-text-container">
        <div v-if="isExpanded" class="text-container expanded">{{ text }}</div>
        <div v-else class="text-container">{{ truncatedText }}</div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, computed } from 'vue';

  const TRUNCATE_LENGTH = 2000
  
  export default defineComponent({
    props: {
      text: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      const isExpanded = ref(false);
  
      const toggleExpand = () => {
        isExpanded.value = !isExpanded.value;
      };
  
      const truncatedText = computed(() => {
        return props.text.length > TRUNCATE_LENGTH
          ? props.text.substring(0, TRUNCATE_LENGTH) + '...'
          : props.text;
      });
  
      const copyText = () => {
        navigator.clipboard.writeText(props.text).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      };
  
      return {
        isExpanded,
        toggleExpand,
        truncatedText,
        copyText,
      };
    },
  });
  </script>
  
  <style scoped>
  h2 {
    text-align: center;
    margin-bottom: 10px;
  }
  
  .json-text-container {
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    margin-top: 10px;
  }
  
  .text-container {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  
  .expanded {
    max-height: none;
  }
  
  button {
    display: block;
    margin: 5px auto;
    padding: 5px 10px;
    border: none;
    background-color: #007BFF;
    color: white;
    cursor: pointer;
    border-radius: 3px;
    font-size: 16px;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  </style>
  